import { defineMessages } from 'react-intl';

export default defineMessages({
    pageNotFound: {
        id: 'global.pageNotFound',
        defaultMessage: 'Página não encontrada',
    },
});
